import { Fragment } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedName from 'I18n/components/FormattedName';
import { ROOT_FONT_SIZE } from 'HubStyleTokens/sizes';
import HR from 'UIComponents/elements/HR';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import UIButton from 'UIComponents/button/UIButton';
// @ts-expect-error untyped import
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReviewReplyThread({
  reply: replyMap,
  onReportReplyClick,
  TagComponent,
  vrHidden = true
}) {
  const {
    reply,
    repliedAt,
    replierDisplayName,
    avatarUrl,
    companyName
  } = replyMap;
  if (!reply) {
    return null;
  }
  const displayName = replierDisplayName || I18n.text('marketplace-ui-reviews.defaultReplierName');
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(HR, {}), TagComponent && /*#__PURE__*/_jsx(TagComponent, {}), /*#__PURE__*/_jsxs(UIFlex, {
      "data-test-id": "review-reply-thread",
      direction: "column",
      className: "p-left-12",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        className: 'm-bottom-2' + (vrHidden ? " vr-hidden" : ""),
        children: [/*#__PURE__*/_jsx(UIAvatar, {
          size: "xs",
          src: avatarUrl
        }), /*#__PURE__*/_jsx("span", {
          style: {
            fontSize: ROOT_FONT_SIZE
          },
          className: "m-x-3",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: companyName ? 'marketplace-ui-reviews.replyThread.title_jsx' : 'marketplace-ui-reviews.replyThread.titleWithoutCompany_jsx',
            options: {
              displayName,
              companyName
            },
            elements: {
              Name: FormattedName,
              Bold: 'b'
            }
          })
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: repliedAt,
            format: "ll",
            type: "userTz"
          })
        })]
      }), /*#__PURE__*/_jsx(UIFlex, {
        children: /*#__PURE__*/_jsx("span", {
          "data-test-id": "review-reply-text",
          children: reply
        })
      }), onReportReplyClick && /*#__PURE__*/_jsx(UIButton, {
        use: "link",
        className: "m-top-2",
        onClick: onReportReplyClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-reviews.replyThread.report"
        })
      })]
    })]
  });
}